import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import {
  SecondaryButton,
  TertiaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import KeywordsFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/keywords_filters_group';
import ApplicationHistoryFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/application_history_filters_group'; // eslint-disable-line max-len
import CandidateFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/rediscovery_candidate_filters_group'; // eslint-disable-line max-len
import JobDetailsFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/job_details_filters_group';
import AdvancedFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/advanced_filters_group';
import { useRediscoveryTabContext } from 'talent_matching/contexts/rediscovery_tab_context';
import EditIcon from '@grnhse/seedling/lib/birch/icons/edit';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  onLoadFilters?: () => void;
  onSaveFilters?: () => void;
};

const RediscoveryFilterRow = ({
  onClearAll,
  onLoadFilters,
  onSaveFilters,
}: Props) => {
  const { savedFilterSet } = useRediscoveryTabContext();

  return (
    <Stack spacing={0} sx={{ marginBottom: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <KeywordsFiltersGroup />
          <ApplicationHistoryFiltersGroup />
          <CandidateFiltersGroup />
          <JobDetailsFiltersGroup />
          <AdvancedFiltersGroup />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
        <NoWrap spacing={1} direction="row" alignItems="center">
          {savedFilterSet ? (
            <TertiaryButton
              size="md"
              onClick={onLoadFilters}
              icon={EditIcon}
              placement="right"
            >
              {savedFilterSet.label}
            </TertiaryButton>
          ) : (
            <TertiaryButton size="md" onClick={onLoadFilters}>
              {t('saved_filters.load')}
            </TertiaryButton>
          )}
          <SecondaryButton size="md" onClick={onSaveFilters}>
            {t('saved_filters.save_filters')}
          </SecondaryButton>
        </NoWrap>
      </Stack>
    </Stack>
  );
};

export default RediscoveryFilterRow;
